import { getUserRolesFromToken } from './settingsAccess';

export type BookingPermission =
  | 'ViewBookings'
  | 'ManageBookings'
  | 'ManageServices'
  | 'ManageAvailability'
  | 'ViewReports'
  | 'ManageSettings';

const MANAGE_ROLES = ['admin', 'system'];

export const hasBookingPermission = (
  token: string | null,
  permission: BookingPermission
): boolean => {
  if (!token) {
    return false;
  }

  const roles = getUserRolesFromToken(token).map(
    (role) => role.toLowerCase()
  );

  const isManager = roles.some((role) =>
    MANAGE_ROLES.includes(role)
  );

  if (isManager) {
    return true;
  }

  switch (permission) {
    case 'ViewBookings':
    case 'ManageBookings':
    case 'ManageServices':
    case 'ManageAvailability':
    case 'ViewReports':
    case 'ManageSettings':
      return true;

    default:
      return false;
  }
};